import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * Recycle Bin Properties.
 *
 * The real property sheet, not a message box: a Global page carrying the
 * one-setting-for-all-drives choice, a page per drive — there is one — and the
 * delete confirmation checkbox along the bottom. XP reached it from the bin's
 * File menu, from its background, and from the desktop icon; all three land
 * here.
 *
 * A dialog rather than a program, which is what a property sheet raised from
 * a context menu was: no taskbar button, Escape closes it, and it opens over
 * whatever asked for it.
 */
export const recyclePropsApp: AppManifest = {
  id: 'recycleprops',
  name: 'Recycle Bin Properties',
  icon: '/assets/icons/recycle-bin.svg',
  component: lazy(() => import('./RecycleProps')),

  // The original, to the pixel: a fixed sheet that never grew a grip.
  defaultSize: { w: 372, h: 428 },
  resizable: false,
  maximizable: false,
  singleton: true,
  dialog: true,
  showInAllPrograms: false,

  titleFor: () => 'Recycle Bin Properties',
};
